import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询点播功能总览数据
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] aid
 * @param {string} [data.cid] cid
 */

export function funcvodoverview(data: DataModel, options: IRequestOptionsWithPass): Promise<any>
export function funcvodoverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<any extends { msg: unknown } ? any['msg'] : undefined>
export function funcvodoverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/vod/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
